import React from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import '../components/css/Payment.css';

const MonthlySuccess = () => {
  return (
    <>
      <Header />
      <Banner />
      <div className="dashboard success-page">
        <div className="subscription-card success-card silver">
          <h1>✔️</h1>
          <h2>Mesačné predplatné aktivované!</h2>
          <p>Ďakujeme za vaše mesačné predplatné. Vaše služby sú teraz aktívne.</p>
          <a href="/" className="subscribe-button">Domov</a>
        </div>
      </div>
    </>
  );
};

export default MonthlySuccess;
